import React from 'react';
import { useParams, useNavigate, useLocation } from "react-router-dom";
import { useEffect, useState, useContext, Fragment } from "react";
import { api_domain } from "../config"
import { AdTable } from '../components/adTable';
import { AdTile } from "../components/adTile";
import Menu from "../components/navbar.js";
import { AuthContext } from "../components/AuthContext";

function useQuery() {
    const { search } = useLocation();
    return React.useMemo(() => new URLSearchParams(search), [search]);
}  

export function Batch() {
    const [batch, setBatch] = useState(null);
    const [ads, setAds] = useState(null);
    const { basicHttpAuthString } = useContext(AuthContext);

    let params = useParams();
    const navigate = useNavigate();
    const location = useLocation();
    let usequery = useQuery();
    let page = parseInt(usequery.get("page"))
    let blur = usequery.get("blur") ? usequery.get("blur") : "true"

    let view = usequery.get("view")
       if (!view) {
          view = "table"
     }

    useEffect(() => {
        if (!page) {
            navigate(location.pathname + "?page=1&view=" + view + "&blur=" + blur)
        }    
    }, [location.pathname, navigate, page])

    const prev_page = () => {
        navigate(location.pathname + location.search.substring(0, location.search.indexOf("page")) + `page=${page-1}` 
		+ `&view=` + view + `&blur=` + blur)
    }
    
    const next_page = () => {
    navigate(location.pathname + location.search.substring(0, location.search.indexOf("page")) + `page=${page+1}` 
	    	+ `&view=` + view + `&blur=` + blur)
    }    

    useEffect(() => {
        fetch(`${api_domain}/batch/${params.batchId}`, {
          headers: {
            Authorization: `${basicHttpAuthString}`
          }
        })
            .then(response => response.json())
            .then(data => setBatch(data))
    }, [params.batchId])

    useEffect(() => {
        fetch(`${api_domain}/search/ad?batch_id=${params.batchId}&page=${page}`, {
          headers: {
            Authorization: `${basicHttpAuthString}`
          }
        })
            .then(response => response.json())
            .then(data => setAds(data))
    }, [params.batchId, page])

    return <div className="container">
        <Menu/> 
        <div className="tools">
        {batch &&
            <div>
                <div className="titleMain">Batch: {batch.id}</div>
                {batch.human_name &&  <div className="titleMinor"><b>human name:</b> {batch.human_name}</div>}
                {batch.batch_date &&  <div className="titleMinor"><b>date:</b> {new Date(batch.batch_date).toString()}</div>}
                {batch.batch_type &&  <div className="titleMinor"><b>batch type:</b> 
                
                { batch.batch_type === 1 ? " crawl" 
                  : batch.batch_type === 2 ? " dataset" 
                  : batch.batch_type === 3 ? " Custom crawl" 
                  : batch.batch_type === 4 ? " OpenWPM crawl"
                  : " Unknown" }
                  
                </div>}
                {batch.extra_metadata && <p><b>extra metadata:</b> <pre><code>{JSON.stringify(batch.extra_metadata, null, 4)}</code></pre></p>}
            </div>}
        <div className="batchDivOne">Ads in Batch {params.batchId}</div>
       
	<div className="btn-group" data-toggle="buttons">
            <input type="radio" className="btn-check" name="options" id="table" checked={view === "table"} onChange={() => navigate(location.pathname + location.search.substring(0, location.search.indexOf("view")) + `view=table` + `&blur=` + usequery.get("blur"))}/>
            <label className="btn btn-secondary" htmlFor="table">Table View</label>
            <input type="radio" className="btn-check" name="options" id="tile" checked={view !== "table"} onChange={() => navigate(location.pathname + location.search.substring(0, location.search.indexOf("view")) + `view=tile` + `&blur=` + usequery.get("blur"))}/>
            <label className="btn btn-secondary" htmlFor="tile">Tile View</label>

            {usequery.get("blur") === "true" ? <input type="radio" className="btn-check" name="options" id="blur" onClick={() => navigate(location.pathname + location.search.substring(0, location.search.indexOf("blur")) + `blur=false`)}/> : <input type="radio" className="btn-check" name="options" id="blur" onClick={() => navigate(location.pathname + location.search.substring(0, location.search.indexOf("blur")) + `blur=true`)}/> }
            {usequery.get("blur") === "true" ? <label className="btn btn-secondary" htmlFor="blur">Unblur Screenshots</label> : <label className="btn btn-secondary" htmlFor="blur">Blur Screenshots</label>}
          </div>

       { view === "table" ? ads && ads.items && <AdTable results={ads} prev_page={prev_page} next_page={next_page} blur={usequery.get("blur")}/> :
                            ads && ads.items && <AdTile results={ads} prev_page={prev_page} next_page={next_page} blur={usequery.get("blur")}/> }
    </div>
    </div>
}
